import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function ArrowDownwardIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 20.4168C11.5 20.4168 11 19.9168 11 19.4168V3.41681C11 2.91681 11.5 2.41681 12 2.41681C12.5 2.41681 13 2.91681 13 3.41681V19.4168C13 19.9168 12.5 20.4168 12 20.4168Z"
				fill="currentColor"
			/>
			<path
				d="M4.70522 12.7089C5.09452 12.3196 5.72562 12.3194 6.11522 12.7084L11.9999 18.5842L17.8847 12.7084C18.2743 12.3194 18.9054 12.3196 19.2947 12.7089C19.6842 13.0984 19.6842 13.73 19.2947 14.1195L12.7071 20.7071C12.3165 21.0976 11.6834 21.0976 11.2928 20.7071L4.70522 14.1195C4.31571 13.73 4.31571 13.0984 4.70522 12.7089Z"
				fill="currentColor"
			/>
		</svg>
	);
}

ArrowDownwardIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default ArrowDownwardIcon;
